import { Subscription } from 'rxjs';
import { CandidateStore } from '../../../dashboards/store/candidate-store';
import { StaticFilePaths } from '../../../shared/constants/static-file-paths';
import { FileTypes } from '../../../shared/enums/file-types';
import { FileHelper } from '../../../shared/helpers/file-helper';
import { RegexStrings } from '../../../shared/constants/regex-strings';
import { environment } from '../../../../environments/environment';
import { PreviewAttachment } from '../../../shared/models/experience-attachment';
import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { AttachmentTypes } from '../../../shared/enums/attachment-types';
import { RegexPatternHelper } from '../../../shared/helpers/regex-pattern-helper';
import { ComponentTypes } from '../../../shared/enums/component-type';

@Component({
  selector: 'app-attachments-preview',
  templateUrl: './attachments-preview.component.html',
  styleUrls: ['./attachments-preview.component.scss'],
})
export class AttachmentsPreviewComponent implements OnInit, OnDestroy {
  @Input() attachments: any;
  @Input() componentType: ComponentTypes;
  @Input() canDelete: boolean = true;
  attachmentTypes = AttachmentTypes;
  fileTypes = FileTypes;
  attachmentList: PreviewAttachment[] = [];
  subscription: Subscription;
  uiClass = 'col-lg-4 col-md-6 pt-2';
  constructor(private candidateStore: CandidateStore) {}

  ngOnInit() {
    if (this.componentType == ComponentTypes.PortfolioComponent) {
      this.subscription = this.candidateStore.portoflios$.subscribe((x) => {
        this.uiClass = 'col-lg-3 col-md-4 pt-2';
        if (x && x.length > 0) {
          this.attachmentList = [] = x as any as PreviewAttachment[];
          this.handleAttachmentCases();
        }
      });
    } else if ( this.componentType == ComponentTypes.ExperienceComponent) {
      this.uiClass = 'col-lg-12 pt-2';
      this.attachmentList = [] = this.attachments as PreviewAttachment[];
      this.handleAttachmentCases();
    } else if (this.attachments && this.attachments.length > 0) {
      this.attachmentList = [] = this.attachments as PreviewAttachment[];
      this.handleAttachmentCases();
    } else {
      this.attachmentList = [];
    }
  }

  handleAttachmentCases = () => {
    this.attachmentList.forEach((attachment) => {
      if (attachment.attachmentType == this.attachmentTypes.URL) {
        attachment.isYoutubeVideoLink = RegexPatternHelper.isValidPattern(
          attachment.url,
          RegexStrings.YOUTUBE_VIDEO_LINK
        );
        attachment.isAudioLink = RegexPatternHelper.isValidPattern(
          attachment.url,
          RegexStrings.AUDIO_LINK
        );
        attachment.attachmentUIPath = attachment.isYoutubeVideoLink || attachment.isAudioLink
          ? `${attachment.url}`
          : `/${StaticFilePaths.PreviewImage}`;
      } else {
        attachment.fileType = FileHelper.getFileType(attachment.filePath);
        attachment.attachmentUIPath = `${environment.baseUrl}/${attachment.filePath}`;
      }
    });
  };

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  handleOnDeleteAttachment = (attachmentId: string) => {
    this.candidateStore.deletePortfolioAttachment(attachmentId);
  }
}
